export const _slideshow = [
  {
    image_url: "/media/banners/14.jpg",
    show_link: "/product/luce",
    title: "Luce",
    title_color: "black",
  },
  {
    image_url: "/media/banners/15.jpg",
    show_link: "/product/eterna",
    title: "Eterna",
    title_color: "black",
  },
  {
    image_url: "/media/banners/17.jpg",
    show_link: "/product/senso",
    title: "Senso",
    title_color: "black",
  },
  {
    image_url: "/media/banners/13.jpg",
    show_link: "/product/luce",
    title: "Luce",
    title_color: "black",
  },
  {
    image_url: "/media/banners/16.jpg",
    show_link: "/product/eterna",
    title: "Eterna",
    title_color: "black",
  },
  {
    image_url: "/media/banners/18.jpg",
    show_link: "/product/senso",
    title: "Senso",
    title_color: "black",
  },
  {
    image_url: "/media/banners/12.jpg",
    show_link: "/product/luce",
    title: "Luce",
    title_color: "black",
  }
];
